module.exports = __webpack_public_path__ + "assets/img/news3.2.f9e4cd35.png";